import { IStudentSummaryResponse } from "@/types/views/student.types";
import { useAppQuery } from "./useAppQuery";

interface Props {
    searchText?: string;
    facultyIds?: string[];
    courseIds?: string[];
    providerId?: string;
    enrolmentDateFrom?: string;
    enrolmentDateTo?: string;
    completedDateFrom?: string;
    completedDateTo?: string;
    dueDateFrom?: string;
    dueDateTo?: string;
    expiryDateFrom?: string;
    expiryDateTo?: string;
}

export const useGetStudentStats = ({ searchText, facultyIds, courseIds, providerId, enrolmentDateFrom, enrolmentDateTo, completedDateFrom, completedDateTo, dueDateFrom, dueDateTo, expiryDateFrom, expiryDateTo }: Props = {}) => {
    return useAppQuery<IStudentSummaryResponse>(
        '/TrainingManager/students/summary',
        {
            config: {
                params: {
                    searchText: searchText || undefined,
                    facultyIds: facultyIds?.length ? facultyIds : undefined,
                    courseIds: courseIds?.length ? courseIds : undefined,
                    providerId: providerId || undefined,
                    enrolmentDateFrom,
                    enrolmentDateTo,
                    completedDateFrom,
                    completedDateTo,
                    dueDateFrom,
                    dueDateTo,
                    expiryDateFrom,
                    expiryDateTo,
                },
                paramsSerializer: { indexes: null },
            },
            placeholderData: undefined,
        }
    );
}